export default {
    install: (Vue: any) => {
        Vue.directive('touch', {
            bind: (el:HTMLElement, binding: any, vnode: any) => {
                const touchType = binding.arg

                let startY: any, endY: any


                function getSwipeDirection(startY: any, endY: any) {
                    let dy = endY - startY
                    if (Math.abs(dy) < 2) {
                        return 'NoSwipe'
                    }

                    if (dy > 0) {
                        return 'SwipeDown'
                    } else if(dy < 0) {
                        return 'SwipeUp'
                    }
                }

                el.addEventListener('touchstart', (e: TouchEvent) => {
                    startY = e.touches[0].pageY
                    if (touchType === 'start') {
                        binding.value()
                    }
                })

                el.addEventListener('touchend', (e: TouchEvent) => {
                    endY = e.changedTouches[0].pageY
                    let direction = getSwipeDirection(startY, endY)

                    switch (direction) {
                        case 'SwipeUp':
                            if (touchType === 'up') {
                                binding.value()
                            }
                            break;
                        case 'SwipeDown':
                            if (touchType === 'down') {
                                binding.value()
                            }
                            break;
                        case 'NoSwipe':
                            if (touchType === 'end') {
                                binding.value(e)
                            }
                            break;
                        default:
                            break;
                    }
                })
            }   
        })
    }
}